// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  .latestDrawnBall {
    height: 4rem;
    width: 4rem;
    background-color: white;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size:2rem;
    font-weight: 700;
   
    z-index: 501;
  }
  .animation-fade{
    animation: fadeInOut 4s ease-in-out forwards;
  }
  
  @keyframes fadeInOut {
    0% {
      opacity: 1;
    }
  
    50% {
      opacity: 1;
    }
  
    100% {
      opacity: 0;
    }
  }
  
  .mainNumber {
    background: linear-gradient(135deg, #dbbbff, #9f58f2, #7725d6);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    color: #ffffff;
  }
  
  .bonusNumber {
    background: linear-gradient(135deg, #ffb18d, #fe9260, #e95f1e);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    color: #5f3372;
  }
  
  
  /* Blinking animation */
  @keyframes blink {
  
    0%,
    100% {
      opacity: 1;
    }
  
    50% {
      opacity: 0;
    }
  }

  @media screen and (max-width:768px) {
  
   
    .latestDrawnBall {
      height: 3rem;
      width: 3rem;
      font-size: 1.5rem;
     
    }
  
  }
 `, "",{"version":3,"sources":["webpack://./src/components/ManualNumber/ManualNumber.css"],"names":[],"mappings":";EACE;IACE,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;;IAEhB,YAAY;EACd;EACA;IACE,4CAA4C;EAC9C;;EAEA;IACE;MACE,UAAU;IACZ;;IAEA;MACE,UAAU;IACZ;;IAEA;MACE,UAAU;IACZ;EACF;;EAEA;IACE,8DAA8D;IAC9D,wCAAwC;IACxC,cAAc;EAChB;;EAEA;IACE,8DAA8D;IAC9D,wCAAwC;IACxC,cAAc;EAChB;;;EAGA,uBAAuB;EACvB;;IAEE;;MAEE,UAAU;IACZ;;IAEA;MACE,UAAU;IACZ;EACF;;EAEA;;;IAGE;MACE,YAAY;MACZ,WAAW;MACX,iBAAiB;;IAEnB;;EAEF","sourcesContent":["\n  .latestDrawnBall {\n    height: 4rem;\n    width: 4rem;\n    background-color: white;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size:2rem;\n    font-weight: 700;\n   \n    z-index: 501;\n  }\n  .animation-fade{\n    animation: fadeInOut 4s ease-in-out forwards;\n  }\n  \n  @keyframes fadeInOut {\n    0% {\n      opacity: 1;\n    }\n  \n    50% {\n      opacity: 1;\n    }\n  \n    100% {\n      opacity: 0;\n    }\n  }\n  \n  .mainNumber {\n    background: linear-gradient(135deg, #dbbbff, #9f58f2, #7725d6);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    color: #ffffff;\n  }\n  \n  .bonusNumber {\n    background: linear-gradient(135deg, #ffb18d, #fe9260, #e95f1e);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    color: #5f3372;\n  }\n  \n  \n  /* Blinking animation */\n  @keyframes blink {\n  \n    0%,\n    100% {\n      opacity: 1;\n    }\n  \n    50% {\n      opacity: 0;\n    }\n  }\n\n  @media screen and (max-width:768px) {\n  \n   \n    .latestDrawnBall {\n      height: 3rem;\n      width: 3rem;\n      font-size: 1.5rem;\n     \n    }\n  \n  }\n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
